import styled from "styled-components";

const RightPositionSection = styled.section`
  display: flex;
  justify-content: flex-end;
  width: 100%
`;

export default RightPositionSection;
